import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { wintextObj } from './wintext';
import QuoteForm from './QuoteForm';
import CESDialogSuccess from './CESDialogSuccess';
import { useScheduledContent } from '@/utils/hooks/useScheduledContent';

export default function QuoteWinSimple({ callback, className }: any) {
    const [stepVal, setStepVal] = useState('a1');
    const { locale, pathname } = useRouter();
    const wintext = wintextObj[locale as any] || wintextObj['us'];
    const [isClient, setIsClient] = useState<boolean>(false);
    const THEME_WHITE = ['/ef-quote-form', '/delta-pro-3-portable-power-station', '/calculators/delta-pro-ultra', '/power-preparedness'];
    const theme = THEME_WHITE.includes(pathname) ? 'white' : 'black';

    // 保星期天自动上线的逻辑，后续可以删掉
    const isNew = useScheduledContent({
        '2025/01/01 10:00:00': false,
        '2026/01/11 15:00:00': true,
    });

    // 关闭
    const closeHandle = () => {
        callback && callback('close');
    };

    useEffect(() => {
        setIsClient(true);
    }, []);

    // 成功回调
    const successCallback = () => {
        setStepVal('a2');
    };

    if (isClient) {
        return ReactDOM.createPortal(
            <div
                className={`${css.VoucherWin} ${css.QuoteWinSimple} ${className} theme-${theme} GtmModuleData-section`}
                data-section-id={'dpu-QuoteWin'}
                data-section-title={'dpu-QuoteWin'}
            >
                {stepVal === 'a1' && (
                    <div className="win-container win-container-quote mode-dialog">
                        <span className="win-close" onClick={closeHandle}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                                <path
                                    d="M16.25 2.70834C23.7287 2.70852 29.791 8.77159 29.791 16.2503C29.7908 23.7289 23.7286 29.7912 16.25 29.7914C8.77125 29.7914 2.70818 23.729 2.70801 16.2503C2.70801 8.77148 8.77114 2.70834 16.25 2.70834ZM21.0303 11.4701C20.6337 11.0735 19.9914 11.0735 19.5947 11.4701L16.25 14.8148L12.9053 11.4701C12.5087 11.0735 11.8664 11.0735 11.4697 11.4701C11.0731 11.8667 11.0731 12.509 11.4697 12.9056L14.8145 16.2503L11.4697 19.5951C11.0731 19.9917 11.0731 20.634 11.4697 21.0306C11.8664 21.4268 12.5088 21.4271 12.9053 21.0306L16.25 17.6859L19.5947 21.0306C19.9914 21.4268 20.6338 21.4271 21.0303 21.0306C21.4267 20.6341 21.4265 19.9917 21.0303 19.5951L17.6855 16.2503L21.0303 12.9056C21.4267 12.5091 21.4265 11.8667 21.0303 11.4701Z"
                                    fill="#83868A"
                                />
                            </svg>
                        </span>
                        <div className="win-info ">
                            <EcoImg
                                pc="https://websiteoss.ecoflow.com/upload/image/1766042237759/pc-banner-dialog.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1766042237337/m-banner-dialog.jpg"
                            />
                            <div className="win-title">{wintext.win_simple_title}</div>
                            <div className="win-desc">{isNew ? wintext.win_simple_desc2 : wintext.win_simple_desc}</div>
                            {!isNew && (
                                <div className="win-tips">
                                    <span>{wintext.win_simple_tips}</span>
                                    <div className="win-tips-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path
                                                d="M8 1.33331C11.6819 1.33331 14.667 4.31841 14.667 8.00031C14.6668 11.6821 11.6818 14.6663 8 14.6663C4.31833 14.6662 1.33415 11.682 1.33398 8.00031C1.33398 4.31849 4.31822 1.33345 8 1.33331ZM7.92773 11.804C7.59654 11.8042 7.32812 12.0724 7.32812 12.4036C7.32813 12.7349 7.59655 13.003 7.92773 13.0032H7.93555C8.26691 13.0032 8.53613 12.735 8.53613 12.4036C8.53613 12.0723 8.26692 11.804 7.93555 11.804H7.92773ZM8.37109 3.84308C7.67302 3.72344 6.95439 3.85438 6.34375 4.2132C5.73308 4.57215 5.2683 5.13581 5.0332 5.80402C4.92329 6.11646 5.08808 6.45951 5.40039 6.56964C5.71298 6.6796 6.05605 6.51505 6.16602 6.20245C6.30701 5.80179 6.58509 5.46372 6.95117 5.24835C7.31753 5.03304 7.74913 4.95396 8.16797 5.0257C8.58676 5.09754 8.96651 5.31594 9.24023 5.64093C9.51384 5.96597 9.66455 6.37721 9.66406 6.80206V6.80304C9.66406 7.28452 9.29423 7.72798 8.73047 8.10382C8.46697 8.27946 8.19939 8.41439 7.99512 8.50519C7.89389 8.55017 7.80975 8.58315 7.75293 8.6048C7.72472 8.61554 7.70303 8.62341 7.68945 8.62823C7.68277 8.6306 7.67744 8.63221 7.6748 8.63312C7.67386 8.63348 7.6731 8.63401 7.67285 8.63409H7.67383C7.42908 8.71582 7.26379 8.94539 7.26367 9.20343V10.4036C7.26383 10.7346 7.53234 11.0028 7.86328 11.0032C8.19455 11.0032 8.46371 10.7349 8.46387 10.4036V9.6087C8.46976 9.60611 8.47642 9.6045 8.48242 9.60187C8.72801 9.49272 9.06019 9.32701 9.39648 9.10284C10.0327 8.67868 10.8633 7.92156 10.8633 6.80304C10.864 6.09507 10.6142 5.40913 10.1582 4.86749C9.70206 4.32598 9.06893 3.96286 8.37109 3.84308Z"
                                                fill="#595C61"
                                            />
                                        </svg>
                                        <div className="win-tips-content">{wintext.win_simple_tips_content}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="win-mainer scrollbar-editor-black">
                            <QuoteForm callback={successCallback} simple />
                            <div className="win-form-footer">
                                {wintext.win_quote_simple_f1}
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path
                                            d="M16.8074 14.1492L13.868 11.2096C13.6906 11.0327 13.4504 10.9334 13.1999 10.9334C12.9494 10.9334 12.7091 11.0327 12.5318 11.2096L11.8637 11.8777C11.4858 12.2556 10.2621 11.8795 9.1915 10.8088C8.12094 9.73814 7.74408 8.515 8.12259 8.13662L8.79067 7.46854C8.96758 7.2912 9.06692 7.05094 9.06692 6.80046C9.06692 6.54997 8.96758 6.30971 8.79067 6.13238L5.85109 3.19293C5.67377 3.01603 5.43353 2.91669 5.18306 2.91669C4.9326 2.91669 4.69236 3.01603 4.51504 3.19293L3.84696 3.86101C3.35331 4.35465 3.05263 5.00396 2.95307 5.79096C2.86072 6.52092 2.94587 7.33957 3.20604 8.22377C3.72792 9.99996 4.90488 11.8673 6.51917 13.4811C8.13345 15.0949 10.0005 16.2724 11.7761 16.7942C12.4302 16.9866 13.0482 17.0833 13.621 17.0833C13.8177 17.0837 14.0142 17.0716 14.2094 17.0472C14.9964 16.9477 15.6457 16.647 16.1393 16.1533L16.8074 15.4852C16.9843 15.3079 17.0837 15.0677 17.0837 14.8172C17.0837 14.5668 16.9843 14.3265 16.8074 14.1492Z"
                                            stroke="#3F68E0"
                                            strokeWidth="1.33333"
                                        />
                                    </svg>
                                    <a href="facetime:+1(800)-368-8604">{wintext.win_quote_simple_f2}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {stepVal === 'a2' &&
                    (['/ces-2026'].includes(pathname) ? (
                        <CESDialogSuccess callback={closeHandle} />
                    ) : (
                        <div className="win-container win-container-quote-success">
                            <span className="win-close" onClick={closeHandle}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="system/line/cancel">
                                        <path
                                            id="Combined-Shape"
                                            d="M6 5L19 18M19 5L6 18"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </g>
                                </svg>
                            </span>
                            <div className="win-mainer win-mainer-quote-success">
                                <div className="win-success-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18ZM23.9062 12.5303C24.1991 12.2374 24.674 12.2374 24.9669 12.5303L26.0275 13.591C26.3204 13.8839 26.3204 14.3588 26.0275 14.6517L16.4816 24.1976C16.4005 24.2787 16.3054 24.3374 16.2041 24.3735L16.1732 24.4045C15.8803 24.6974 15.4054 24.6974 15.1125 24.4045L9.53081 18.8228C9.23792 18.5299 9.23792 18.055 9.53081 17.7621L10.5915 16.7015C10.8844 16.4086 11.3592 16.4086 11.6521 16.7015L15.6936 20.7429L23.9062 12.5303Z"
                                            fill="#30BF00"
                                        />
                                    </svg>
                                    <span>{wintext.win_quote_success1}</span>
                                </div>
                                <div className="win-success-desc">{wintext.win_quote_success2}</div>
                            </div>
                        </div>
                    ))}
            </div>,
            (document as any).body,
        );
    }
    return <></>;
}
